// Main JS file for site
// --------------------------------------------------

// `pp` must stay a browser global: footer.php loads the Google Maps API with
// `callback=pp.sitewide.googleMaps`, and webpack scopes a module-level `var`.
window.pp = window.pp || {};
var pp = window.pp;

// Home
// ----------------------------------------------

pp.home = {
    init: function() {
        this.news();
        this.callstoaction.init();
    },
    // Home page news carousel
    news: function() {
        var news  = $('#home-news'),
            links = $(".home-news__nav ul a");

        if( news.length ){
            // Carousel
             $.fn.carouFredSel.pageAnchorBuilder = function(nr, item) {
                var heading = $('#home-news li:eq(' + (nr-1) + ') h3').data('title-short');
                return '<li><a href="#news-'+nr+'">'+heading+'</a></li>';
            };

            var carouselInit = false;
            var BREAKPOINT = 992;

            var checkCarousel = function() {
                if (window.innerWidth < BREAKPOINT) {
                    handleDestroy();
                } else {
                    handleInit();
                }
            };

            var handleDestroy = function() {
                if (!carouselInit) {
                    return;
                }

                news.trigger('destroy');

                news.find('.card').each(function() {
                    $(this).addClass('card--horizontal');
                    $(this).css({minHeight: 'auto'});
                });

                carouselInit = false;
            };

            var handleInit = function() {
                if (carouselInit) {
                    return;
                }

                news.find('.card').each(function() {
                    $(this).removeClass('card--horizontal');
                });

                pp.sitewide.setCards();

                news.carouFredSel({
                    auto: 8000,
                    width: "100%",
                    height: 'auto',
                    responsive:true,
                    items: {
                        visible: 3
                    },
                    prev: "#prev",
                    next: "#next",
                    pagination:'#pagination',
                    scroll: {
                        duration: 1000
                    }
                });

                carouselInit = true;
            };

            $(window).resize(function() {
                checkCarousel();
            });

            checkCarousel();

            // Swipe events invoked separately to allow for active links on mobile
            news.swipe({
                swipeLeft: function() {
                    news.trigger('next', 1);
                },
                swipeRight: function() {
                    news.trigger('prev', 1);
                },
                click: function(event, target) {
                    window.open($(target).closest('a').attr('href'), '_self');
                }
            });

            // Carousel navigation
            links.click(function(e) {
                e.preventDefault();
                var $this = $(this),
                    index = $this.parents('li').index();

                $("#home-news").trigger("slideTo", index);

                links.removeClass('active');
                $this.addClass('active');
            });
            // Highlight first news link
            $(".home-news__nav li:eq(0)").addClass('selected');
        }
    },
    callstoaction: {
        init: function() {
            $('.home-callstoaction__action').on('click', pp.home.callstoaction.controller);
        },
        controller: function(e) {
            e.preventDefault();
            var $this    = $(this),
                parent   = $this.parents('.home-callstoaction__article'),
                articles = $('.home-callstoaction__article');

            // Expand clicked element
            if( !parent.hasClass('expand') ) {
                pp.home.callstoaction.expand(parent, $this);
            } else {
                pp.home.callstoaction.contract(parent, $this);
            }
        },
        contract: function(parent, $this) {
            parent.removeClass('expand');
            $this.removeClass('icon-arrow-up').addClass('icon-arrow-down');
        },
        expand: function(parent, $this) {
            parent.addClass('expand');
            $this.removeClass('icon-arrow-down').addClass('icon-arrow-up');
        }
    }
};

// Service
// ----------------------------------------------

pp.service = {
    carousel: $('[data-js-service-slider]'),
    init: function() {
        pp.service.bannerVideo();

        if(pp.service.carousel.length){
            pp.service.initSlider();
        }
        $(window).smartresize(this.initSlider);

        pp.service.carousel.find('[aria-controls]').each(
            function(i, el) {
                // used rather than $.on('click') so that it will be triggered on touch devices
                // jquery swipe plugin blocks buttons and a elements
                $(el).swipe({
                    click: pp.service.toggleFlyout
                });
            }
        );
    },
    // Service-page hero banner video. The desktop <source>s are inline (so the
    // video plays without JS — mobile then gets 1080p). When JS is available and
    // the viewport is ≤767px, swap in the smaller 720p sources before playback.
    bannerVideo: function() {
        var $videos = $('.hero__nav-video');

        if (!$videos.length || !window.matchMedia) {
            return;
        }

        // Respect prefers-reduced-motion (WCAG 2.2.2): the video is decorative and loops
        // indefinitely, so for these users stop the autoplay and leave the poster/first frame.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            $videos.each(function() {
                this.autoplay = false;
                this.pause();
            });
            return;
        }

        if (!window.matchMedia('(max-width: 767px)').matches) {
            return;
        }

        $videos.each(function() {
            var video = this;
            var mobileByType = {
                'video/webm': video.getAttribute('data-webm-mobile'),
                'video/mp4': video.getAttribute('data-mp4-mobile')
            };
            var sources = video.getElementsByTagName('source');
            var i;

            // All-or-nothing: only downgrade to 720p if EVERY inline (desktop) <source> has a
            // matching mobile URL. Otherwise a format left at its 1080p desktop source would be
            // silently served in full to a browser that prefers that format — defeating the swap.
            for (i = 0; i < sources.length; i++) {
                if (!mobileByType[sources[i].getAttribute('type')]) {
                    return;
                }
            }

            for (i = 0; i < sources.length; i++) {
                sources[i].setAttribute('src', mobileByType[sources[i].getAttribute('type')]);
            }

            video.load();
            var playing = video.play();
            if (playing && typeof playing.catch === 'function') {
                playing.catch(function() {}); // ignore autoplay rejection
            }
        });
    },
    initSlider: function() {

        var items = 0;

        if (Modernizr.mq("screen and (min-width:992px)") || $('html').hasClass('lt-ie9') && $(window).width() > 991 ) {
            items = 3;
        } else if (Modernizr.mq("screen and (min-width:650px)") || $('html').hasClass('lt-ie9') && $(window).width() > 650 ) {
            items = 2;
        } else {
            items = 1;
        }

        pp.service.carousel.each(
            function (i, el) {
                var id = el.getAttribute('data-js-service-slider');
                $(el).carouFredSel({
                    auto:false,
                    width:'100%',
                    responsive:true,
                    scroll: {
                        items: 1
                    },
                    items: {
                        visible: items
                    },
                    swipe: {
                        onTouch: true
                    },
                    prev : '[data-js-service-slider-prev=' + id + ']',
                    next : '[data-js-service-slider-next=' + id + ']'
                });
            }
        );

        pp.service.carousel.find('.card__flyout__play-button').swipe({
            click: function (e) {
                var $video = $('#' + $(this).attr('data-js-play'));

                if ($video.length ) {
                    pp.forceLoad($video[0]);
                    $video[0].play();
                    $(this).hide();
                }
            }
        });

        pp.service.carousel.find('video').swipe({click: pp.service.toggleVideoPlay});
    },
    toggleFlyout: function(e, t) {
        var el = t ? t :  e.target;
        var target = el.hasAttribute('aria-controls') ? el : el.closest('[aria-controls]');
        var isExpanded = target.getAttribute('aria-expanded') === 'false';
        pp.service.handleToggle(target, isExpanded);
        pp.service.setNextSlide();
    },
    handleToggle: function(target, isExpanded) {
        if (!target) {
            return;
        }

        var $html = $('html');
        var targetId = target.getAttribute('aria-controls');
        var $target = $('#' + targetId);
        var $toggles = $('[aria-controls=' + targetId + ']');
        var close = target.getAttribute('data-js-close');

        $('.card__flyout--next').removeClass('card__flyout--next');

        $toggles.attr('aria-expanded', isExpanded);
        $target.attr('aria-hidden', !isExpanded);

        if (close) {
            $('[aria-controls=' + close + ']').attr('aria-expanded', false);
            $('#' + close).attr('aria-hidden', true);
        }

        if(isExpanded) {
            $target.focus();
            pp.service.loadImages($target);
            $html.on('keyup', pp.service.handleEsc);
        } else {
            $html.off('keyup', pp.service.handleEsc);
        }

        $html.toggleClass('has-modal', isExpanded);
    },
    loadImages: function($flyout) {
        var $images = $flyout.find('img.lazyload:not(.loaded)');

        if ($images.length === 0) {
            return;
        }

        $images.each(
            function (index, element) {
                pp.forceLoad(element);
            }
        );
    },
    toggleVideoPlay: function(e) {
        var video = e.target;

        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    },
    handleEsc: function(e) {

    var keyCode = e.which || e.keyCode;
    var target = $('[aria-hidden=false] .card__flyout__close');

    if (keyCode !== 27 && e.key !== 'Escape') {
      // Escape
      return;
    }

    pp.service.handleToggle(target[0], false);

    },
    setNextSlide: function(e) {
        pp.service.carousel.find('.card__flyout[aria-hidden=false]').parents('.list__item--carousel').next().find('.card__flyout').addClass('card__flyout--next');
    }
};



// People
// ----------------------------------------------

pp.people = {
    carousel: $('#team-carousel'),
    init: function() {
        if( pp.people.carousel.length ){
            pp.people.initSlider();
        }
        $(window).smartresize(this.initSlider);
    },
    initSlider: function() {

        var items = 0;

        if (Modernizr.mq("screen and (min-width:992px)") || $('html').hasClass('lt-ie9') && $(window).width() > 991 ) {
            items = 3;
        } else if (Modernizr.mq("screen and (min-width:650px)") || $('html').hasClass('lt-ie9') && $(window).width() > 650 ) {
            items = 2;
        } else {
            items = 1;
        }

        pp.people.carousel.carouFredSel({
            auto:false,
            width:'100%',
            responsive:true,
            items: {
                visible: items
            },
            swipe: {
                onTouch: true
            },
            scroll: {
                onBefore: pp.people.handleSlideChange
            },
            prev : "#prev",
            next : "#next"
        });

    },
    handleSlideChange: function(data) {
        var images = data.items.visible.find('img.lazyload:not(.loaded)');
        images.each(
            function (index, element) {
                pp.forceLoad(element);
            }
        );
    }
};


// Contact Us
// ----------------------------------------------

pp.contact = {
    init: function() {

        const $cf7Form = $(".wpcf7-form");

        // Numeric only control handler
        jQuery.fn.forceNumericOnly = function() {
            return this.each(function() {
                $(this).keydown(function(e) {
                    var key = e.charCode || e.keyCode || 0;
                    // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
                    // home, end, period, and numpad decimal
                    return (
                        key == 8 ||
                        key == 9 ||
                        key == 46 ||
                        key == 110 ||
                        key == 190 ||
                        (key >= 35 && key <= 40) ||
                        (key >= 48 && key <= 57) ||
                        (key >= 96 && key <= 105));
                });
            });
        };

        $('#form1_phone').forceNumericOnly();

        if (typeof wpcf7 != 'undefined') {
            wpcf7.blocked = true;
        }

        // Validate contact form
        $cf7Form.removeAttr('novalidate');
        $cf7Form.validate({
            onfocusout: false,
            onkeyup: false,
            rules: {
                Name: "required",
                Email: {
                    required:true,
                    email:true,
                    onfocusout: false,
                    onkeyup: false
                },
                Phone: "required"
            },
            submitHandler: function(form) {
                if (typeof wpcf7 != 'undefined') {
                    wpcf7.blocked = false;
                }
            },
            messages: {
                Name: "Your name  does not appear to be valid.",
                Email: "Your email address does not appear to be valid.",
                Phone: "Your phone number does not appear to be valid."
            },
            invalidHandler: function(event, validator) {
                if( validator.numberOfInvalids() > 0 ) {
                    $('.form-errors').html('<h3>Errors</h3>');
                }
                wpcf7.reset($cf7Form[0]);
            },
            errorPlacement: function(error, element) {
                var id = $(element).attr('id');

                if( id === 'name' ) {
                    error.prepend('<i class="icon-person"></i>');
                } else if( id === 'phone' ) {
                    error.prepend('<i class="icon-phone"></i>');
                } else if( id === 'email' ) {
                    error.prepend('<i class="icon-email"></i>');
                }

                element.parents('.form__row').addClass('error');
                error.appendTo($('.form-errors'));
            },
            errorElement: "p"
        });

    }
};


// Contact Us
// ----------------------------------------------

pp.post = {
    quickLinks: null,
    init: function() {
        pp.post.quickLinks = $('.blog-quicklinks');

        if (pp.post.quickLinks.length) {
            pp.post.createQuicklinks();
            pp.post.desktopOrMobileVersion();
        }

        $(window).smartresize(this.desktopOrMobileVersion);

    },
    createQuicklinks: function () {
        var $links = $('.news-article').find('h2');
        var $list = pp.post.quickLinks.find('ul');

        $links.each( function(index, el) {
            var linkText = el.innerText;
            var linkHref = slug(linkText);

            if (!linkText || !linkHref) {
                return;
            }

            $(el).attr('id', linkHref);

            var newLink =
                "<li class='blog-quicklinks__item'>" +
                "<a class='blog-quicklinks__link border-bot-sweep' href='#" +
                linkHref +
                "' >" +
                linkText +
                '</span></a>' +
                '</li>';

            $list.append(newLink);
        });

        if ($links.length) {
            $list.parent('.none').removeClass('none');
            pp.post.quickLinks.prev().addClass('no-m-b');
        } else {
            pp.post.quickLinks.remove();
        }
    },
    desktopOrMobileVersion: function() {
        if (Modernizr.mq("screen and (max-width:991px)")) {
            pp.post.setupShowMoreToggle();
        } else {
            pp.post.resetShowMoreToggle();
        }
    },
    setupShowMoreToggle: function () {
        var $button = pp.post.quickLinks.find('.blog-quicklinks__button');

        if ($button.length) {
            return;
        }

        var button = '<button class="blog-quicklinks__button button" aria-controls="quicklinks-nav" aria-expanded="true"><span class="visuallyhidden">Show all headings</span><span class="blog-quicklinks__button-icon"></span></button>';

        pp.post.quickLinks.find('.blog-quicklinks__title').after(button);

        pp.post.quickLinks.find('button').on('click', pp.post.handleToggle);

        pp.post.quickLinks.find('.blog-quicklinks__button').click();
    },
    resetShowMoreToggle: function () {
        var $button = pp.post.quickLinks.find('.blog-quicklinks__button');

        $button.remove();

        pp.post.quickLinks.find('li:not(:first-child)').show().attr('hidden', false);
    },
    handleToggle: function (evt) {
        var $button = $(evt.currentTarget);
        var isExpanded = $button.attr('aria-expanded') == 'true';

        $button.attr('aria-expanded', !isExpanded);

        pp.post.quickLinks.find('.blog-quicklinks__list').toggleClass('blog-quicklinks__list--expanded', !isExpanded);
        pp.post.quickLinks.find('li:not(:first-child)').toggle().attr('hidden', !isExpanded);
    }
};

// Navigation
// ----------------------------------------------

pp.nav = {
    nav: $('#main-nav'),
    init: function() {
        this.events();
        this.desktopOrMobileEvents();
    },
    events: function() {
        $('#toggle--navigation').on('click focus', function(e) {
            e.preventDefault();

            // If contact details area is open, close it and then open nav
            if ($('body').hasClass('layout-header__contact--active') || $('body').hasClass('layout-header__search--active')) {
                pp.sitewide.closeContactHeader();
                pp.sitewide.closeSearchHeader();
                setTimeout(function() {
                    pp.nav.openNav();
                }, 350);
            } else {
                pp.nav.openNav();
            }

        });
        $("#close-navigation").on('click', this.closeNav);
        $('#overlay').on('click', this.closeNav);
        $(window).smartresize(this.desktopOrMobileEvents);
        // Back to top level
        pp.nav.nav.on('click', '.view-top-level', this.showTopLevelMenu);

        // Search
        $("[data-js-search]").on('click', this.toggleSearch);
    },
    /**
    *
    * @desc  : Create mobile menu items, back to top level link & add top level link into secondary level links
    *
    */
    buildMobileMenu: function() {

        var $childItemNav = $('.nav>ul>.menu-item-has-children');


        // Add top level item to submenu list
        $childItemNav.each(function(thi) {

            var $this          = $(this),
                $parentAnchor  = $this.find('> a'),
                text           = $parentAnchor.text(),
                url            = $parentAnchor.attr('href');


            // Add top level link to top of submenu so user can click it
            $this.find('>.sub-menu').prepend('<li class="mobile-menu-link"><a href="'+url+'">'+text+' overview</a></li>');

            // Add link back to top level pages
            $this.find('>.sub-menu').prepend('<li class="mobile-menu-link"><a href="#nav" class="view-top-level"><span class="icon-font icon_arrow-left"></span>'+text+'</a></li>');

        });

        // Set a flag to let us know the navs been built
        pp.nav.nav.data('sub-nav-built', true);

    },
    /**
    *
    * @desc  : Events for desktop nav and mobile/tablet nav
    *
    */
    desktopOrMobileEvents: function() {

        // Unbind events so they dont stay & run on wrong size screen
        $(".menu-item-has-children > a").off('click');

        $('#main-nav li').off('mouseover');
        $('#main-nav li').off('mouseout');

        $('#main-nav a').off('focus');
        $('#main-nav a').off('blur');


        if (Modernizr.mq("screen and (min-width:992px)") || $('html').hasClass('lt-ie9') && $(window).width() > 991 ) {

            // Close mobile/tablet nav
            pp.nav.closeNav();
            // Enable desktop functionality
            pp.nav.navDesktop();

        } else {

            $(".nav>ul>.menu-item-has-children > a").on('click focus', function(e) {
                var $this = $(this);
                pp.nav.showSubNav(e, $this);
            });

            // When leave last item in secondary nav go back to top level
            $(".menu-item-has-children  li:last-child a").on('blur', this.showTopLevelMenu);

            // Close nav when blur out of last link
            $('.nav__social__instagram a').on('blur', this.closeNav);


        }

    },
    /**
    *
    * @desc  : Open mobile/tablet nav
    *
    */
    openNav: function(e) {
        if (e) {
            e.preventDefault();
        }

        $('body').addClass('navigation--active');

        if (pp.nav.nav.data('sub-nav-built') === false || pp.nav.nav.data('sub-nav-built') === undefined) {
            pp.nav.buildMobileMenu();
        }
    },
    /**
    *
    * @desc  : Close mobile/tablet nav
    *
    */
    closeNav: function(e) {
        if (e) {
            e.preventDefault();
        }

        // Hide nav
        $('body').removeClass('navigation--active');
        // Rest sub menu
        $('.sub-menu--active').removeClass('sub-menu--active');
        pp.nav.nav.removeClass('nav__top-level--hidden');
    },
    /**
    *
    * @desc  : Show second level nav items in mobile/tablet menu
    * @param : e - event, $this - parent item clicked
    *
    */
    showSubNav: function(e, $this) {
        if (e) {
            e.preventDefault();
        }

        // Hide top level links
        $('.nav__top-level').addClass('nav__top-level--hidden');

        $('.sub-menu--active').removeClass('sub-menu--active');

        $this.parents('li').find('.sub-menu').addClass('sub-menu--active');

        // Wait for menu to slide across then animate to top of it
        setTimeout(function() {
            $('html, body').animate({
                scrollTop: 0
            }, 200);
        }, 350);

    },
    /**
    *
    * @desc  : Show top level links
    *
    */
    showTopLevelMenu: function(e) {
        if (e) {
            e.preventDefault();
        }

        $('.nav__top-level').removeClass('nav__top-level--hidden');
    },

    // Desktop nav functions

    // Ensure users who use keyboard can still navigate to drodown menu
    navDesktop: function() {

        // Add hover class to menu items on hover
        $('#main-nav li').on('mouseover', function(){
                $(this).addClass("hover");
            });

           $('#main-nav li').on('mouseout', function(){
                $(this).removeClass("hover");
            });

        // Add hover class to menu items on focus then remove on blur
        $('#main-nav a').on('focus', function(){
            $(this).parents('li').addClass("hover");
        });

        $('#main-nav a').on('blur', function(){
            $(this).parents('li').removeClass("hover");
        });


    },

    toggleSearch: function() {
        var $buttonEl = $('[data-js-search]');
        var $formEl = $('.header-search__form');
        var activeClass = 'search-is-active';

        $formEl.parent().toggleClass(activeClass);
        $formEl.animate({width:'toggle', opacity: 'toggle'},150);

        if ($formEl.parent().hasClass(activeClass)) {
            $formEl.find('input').focus();
            $buttonEl.attr('aria-expanded', 'true');
        } else {
            $buttonEl.blur();
            $buttonEl.attr('aria-expanded', 'false');
        }

        // $('.header-search__form').show("slide", { direction: "left" }, 1000);
    }
};


// Social feed
// ----------------------------------------------

pp.socialFeed = {
    initialised: false,
    init: function() {
        function handleObserver(entries) {
            Array.from(entries).forEach(
                function(entry) {
                    if (!pp.socialFeed.initialised && entry.isIntersecting) {
                        pp.socialFeed.getData();
                        pp.socialFeed.initialised = true;
                    }
                }
            );
        }

        var observer = new IntersectionObserver(handleObserver, {
            rootMargin: '0px 0px 1000px'
        });

        var socialFeed = this.getContainer();

        observer.observe(socialFeed);
    },

    getData: function() {
        var that = this;

        $.ajax({
            url: '/wp-json/social/v1/get',
            dataType: 'json',
            type: 'get',
            contentType: 'application/json',
            success: function(data, textStatus, jQxhr) {
                var format = that.format(data);

                that.add(format);
            },
            error: function(jqXhr, textStatus, errorThrown) {
                console.log('An error has occurred.');
            }
        });
    },

    getContainer: function() {
        return document.querySelector('[data-js-social-feed]');
    },

    format: function(data) {
        var feed = '';

        Array.from(data).forEach(function(source) {
            var type = source.type;
            var id = source.id;
            var url = source.url;
            var media_type = source.media_type;
            var permalink = source.permalink;
            var timestamp = source.timestamp;
            var date = new Date(timestamp);
            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var caption = source.caption;
            var icon = (type === 'instagram') ? 'instagram' : 'youtube';
            var title = (type === 'instagram') ? '@PurePhysio' : caption;
            var content = (type === 'instagram' && caption) ? (caption.substring(0,120)+'...') : '';

            feed += '<figure class="c-social-feed__item">';
            feed += '<a href="' + permalink + '" class="c-social-feed__link" target="_blank" rel="noopener">';
            feed += '    <div class="ratio ratio--4x5">';
            feed += '       <img src="' + url + '" alt="' + caption + '" class="object-fit c-social-feed__image c-social-feed__image--' + type + '">';
            feed += '    </div>';
            feed += '</a>';
            feed += '</figure>';
        });

        return feed;
    },

    add: function(data) {
        this.getContainer().innerHTML = data;
    },

};

// Iframes
// ----------------------------------------------

pp.iframe = {
    safari: false,

    init: function() {

        try{
            this.safari = !!navigator.userAgent.match(/^((?!chrome|chromium|android).)*safari/i);
        }catch(ex){

        }

        var that = this;


        $('[data-iframe]').find('iframe').each(function(i, elem){
            var src = elem.getAttribute('data-src');
            // var $bookingbutton= $('a[href=#pracsuite-iframe]');

            // workaround for safari
            elem.setAttribute('src', src);

            if(that.safari){
                // $bookingbutton.attr('href', src);
                // $bookingbutton.attr('target', "_blank");
                // $('[data-iframe]').hide();
                // return true;
                elem.src = elem.src;
            }

            var loader = $(elem).closest('[data-iframe]').find('.iframe-loader');

            if(loader.length){
                elem.onload = function() {
                        loader.hide();
                        pp.iframe.events();
                };
            }
        });

        // If user has scrolled down the iframe and the iframe resized, scroll back up
        const pracsuiteiframe = document.getElementById('pracsuite-iframe');

        if (pracsuiteiframe != null) {
            let previousPosition = window.pageYOffset;

            const resizeObserver = new ResizeObserver(entries => {
                for (const entry of entries) {

                    if (entry.target === pracsuiteiframe && previousPosition != window.pageYOffset) {
                        window.scrollTo({
                            top: pracsuiteiframe.getBoundingClientRect().top + window.pageYOffset - 60,
                            behavior: 'smooth',
                        });
                        previousPosition = window.pageYOffset;
                    }
                }
            });

            resizeObserver.observe(pracsuiteiframe);
        }

    },
    events: function() {
        window.addEventListener('message', function (event) {
            if (!event.data) {
                return;
            }

            if (event.data.height) {
                var iframeContainer = document.getElementById('pracsuite-iframe');
                iframeContainer.style.height = (event.data.height + 10) + 'px'; // extra space to prevent scrollbar
            }
        }, false);
    }
};


// Sitewide
// ----------------------------------------------
pp.sitewide = {
    draggable: false,
    mapQueenSt: undefined,
    mapCollinsSt: undefined,
    mapQueenStMobile: undefined,
    mapCollinsStMobile: undefined,
    mapsLoaded: false,
    init: function() {
        this.events();
        this.social();
        this.addClickablePhoneNumbers();
        this.setCards();
        this.images();
        this.externalLinks();
        this.longformToc();
        $('input,select,textarea').focus(pp.sitewide.form.focus);
        $('input,select,textarea').blur(pp.sitewide.form.blur);
    },

    // Build the "On this page" rail (page-longform.php) from the body's H2s and
    // highlight the section currently in view. No-op on any page without the rail.
    longformToc: function() {
        var nav = document.querySelector('.longform-toc');
        var body = document.querySelector('.longform__body');
        if (!nav || !body) { return; }
        var list = nav.querySelector('.longform-toc__list');
        // Only real headings — an empty <h2> (e.g. a grid block with no title)
        // must not produce a blank TOC item.
        var headings = [].slice.call(body.querySelectorAll('h2')).filter(function(h) {
            return (h.textContent || '').trim() !== '';
        });
        if (!list || !headings.length) { return; }

        var used = {};
        var links = [];
        headings.forEach(function(h) {
            var id = h.id;
            if (!id) {
                id = (h.textContent || '').toLowerCase().trim()
                    .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
                if (!id) { id = 'section'; }
                var base = id, n = 2;
                while (used[id] || document.getElementById(id)) { id = base + '-' + (n++); }
                h.id = id;
            }
            used[id] = true;

            var li = document.createElement('li');
            li.className = 'longform-toc__item';
            var a = document.createElement('a');
            a.className = 'longform-toc__link';
            a.href = '#' + id;
            a.textContent = h.textContent;
            a.addEventListener('click', function(e) {
                e.preventDefault();
                setActive(id); // instant feedback; the scroll handler keeps it in sync
                closePanel(); // mobile: collapse the panel + release the scroll lock first
                var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
                // Move focus to the target section so keyboard/SR users follow the jump
                // (preventScroll so it doesn't fight the smooth scroll above).
                if (!h.hasAttribute('tabindex')) { h.setAttribute('tabindex', '-1'); }
                try { h.focus({ preventScroll: true }); } catch (err) { h.focus(); }
                if (history.replaceState) { history.replaceState(null, '', '#' + id); }
            });
            li.appendChild(a);
            list.appendChild(li);
            links.push({ id: id, link: a });
        });

        nav.hidden = false;

        // Mobile: the title acts as a collapse toggle; the list is a dropdown that
        // locks the page behind it and closes when a section is chosen. On desktop
        // the list is always visible, so the toggle is a no-op.
        var toggle = nav.querySelector('.longform-toc__title');
        // Matches the CSS collapsible breakpoint (below the two-column desktop layout).
        var mqMobile = window.matchMedia('(max-width: 991px)');
        // aria-expanded only makes sense in the mobile collapsible; on desktop the
        // list is always visible and the toggle is inert, so the attribute is removed.
        function updateToggleAria() {
            if (!toggle) { return; }
            if (mqMobile.matches) {
                toggle.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
            } else {
                toggle.removeAttribute('aria-expanded');
            }
        }
        function applyOpen() {
            nav.classList.add('is-open');
            document.body.classList.add('longform-toc-open');
            updateToggleAria();
        }
        function openPanel() {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var topNow = nav.getBoundingClientRect().top;
            // Already stuck at the top (or reduced motion) → open in place, no scroll
            // (the fixed panel opens at the same top/left as the stuck bar, so it
            // doesn't jump).
            if (reduce || topNow <= 18) { applyOpen(); return; }
            // Otherwise bring the bar to the top first, then expand — matches the
            // panel's 15px top so the box stays continuous.
            var y = topNow + (window.pageYOffset || 0) - 15;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
            setTimeout(applyOpen, 320);
        }
        function closePanel() {
            nav.classList.remove('is-open');
            document.body.classList.remove('longform-toc-open');
            updateToggleAria();
        }
        if (toggle) {
            toggle.addEventListener('click', function() {
                if (!mqMobile.matches) { return; } // desktop: not a toggle
                if (nav.classList.contains('is-open')) { closePanel(); } else { openPanel(); }
            });
        }
        if (mqMobile.addEventListener) {
            mqMobile.addEventListener('change', function(e) {
                if (!e.matches) { closePanel(); } // leaving mobile → ensure closed
                updateToggleAria();
            });
        }
        // Escape closes the open mobile panel and returns focus to the toggle.
        document.addEventListener('keydown', function(e) {
            if ((e.key === 'Escape' || e.keyCode === 27) && document.body.classList.contains('longform-toc-open')) {
                closePanel();
                if (toggle) { toggle.focus(); }
            }
        });
        updateToggleAria(); // set the initial state for the current viewport

        var activeId = null;
        function setActive(id) {
            if (!id || id === activeId) { return; }
            activeId = id;
            links.forEach(function(x) {
                var on = x.id === id;
                x.link.classList.toggle('is-active', on);
                if (on) { x.link.setAttribute('aria-current', 'true'); }
                else { x.link.removeAttribute('aria-current'); }
            });
        }

        // Scroll-spy: the active item is the last heading scrolled past a fixed
        // offset from the top. To stay smooth during a click-to-scroll, the
        // heading positions are measured ONCE (and on load/resize) into `tops`,
        // so the scroll handler only reads window.pageYOffset — no per-frame
        // getBoundingClientRect (which would force a layout reflow every frame
        // and cause the jank the user saw jumping between sections).
        var OFFSET = 140;
        var tops = [];
        function measure() {
            var y = window.pageYOffset || document.documentElement.scrollTop || 0;
            tops = headings.map(function(h) {
                return h.getBoundingClientRect().top + y;
            });
        }
        function updateActive() {
            var pos = (window.pageYOffset || document.documentElement.scrollTop || 0) + OFFSET;
            var current = headings[0].id;
            for (var i = 0; i < tops.length; i++) {
                if (tops[i] <= pos) {
                    current = headings[i].id;
                } else {
                    break;
                }
            }
            setActive(current);
        }
        var ticking = false;
        window.addEventListener('scroll', function() {
            if (ticking) { return; }
            ticking = true;
            window.requestAnimationFrame(function() { updateActive(); ticking = false; });
        }, { passive: true });
        window.addEventListener('resize', function() { measure(); updateActive(); }, { passive: true });
        window.addEventListener('load', function() { measure(); updateActive(); });
        // Lazyload body images shift heading offsets as they swap in mid-scroll —
        // re-measure once each finishes loading.
        [].slice.call(body.querySelectorAll('img')).forEach(function(img) {
            if (img.complete) { return; }
            img.addEventListener('load', function() { measure(); updateActive(); }, { once: true });
        });
        measure();
        updateActive(); // initial
    },
    events: function() {
        $("#toggle--contact").on('click', this.toggleContactHeader);
        $("#toggle--search").on('click', this.toggleSearchHeader);

        // Make map draggable
        $('.map').on('click', function() {
            if(pp.sitewide.mapQueenSt) {
                pp.sitewide.mapQueenSt.set( 'draggable', true );
            }
            if(pp.sitewide.mapCollinsSt) {
                pp.sitewide.mapCollinsSt.set('draggable', true);
            }
            if(pp.sitewide.mapQueenStMobile) {
                pp.sitewide.mapQueenStMobile.set('draggable', true);
            }
            if(pp.sitewide.mapCollinsStMobile) {
                pp.sitewide.mapCollinsStMobile.set('draggable', true);
            }
            pp.sitewide.draggable = true;
        });

        // Stop map being draggable
        $(window).smartscroll(function() {
            if(pp.sitewide.draggable) {
                if(pp.sitewide.mapQueenSt) {
                    pp.sitewide.mapQueenSt.set( 'draggable', false );
                }
                if(pp.sitewide.mapCollinsSt) {
                    pp.sitewide.mapCollinsSt.set('draggable', false);
                }
                if(pp.sitewide.mapQueenStMobile) {
                    pp.sitewide.mapQueenStMobile.set('draggable', false);
                }
                if(pp.sitewide.mapCollinsStMobile) {
                    pp.sitewide.mapCollinsStMobile.set('draggable', false);
                }
            }
        });
    },
    addClickablePhoneNumbers: function() {

        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            $('.phone-number').each(function() {
                var number = $(this).text();
                var clinic = $(this).data('clinic');
                var location = $(this).data('location');
                $(this).wrapAll('<a href="tel:'+ number.replace(/ /g,'') +'"></a>');
            });
        }

    },
    form: {
        focus: function() {
            $(this).parents('.form__row').addClass('form__row--focused');
        },
        blur: function() {
            $(this).parents('.form__row').removeClass('form__row--focused');
        }
    },
    social: function() {
        $('.social .span4').matchHeight();

        // Make links in tweets open in a new tab
        var links = $('.twitter .tweet blockquote a');
        var len = links.length;
        for(var i=0; i<len; i++)
        {
           links[i].target = "_blank";
        }
    },
    toggleContactHeader: function(e) {
        e.preventDefault();
        // If SEARCH is open, close it first
        if ($('body').hasClass('layout-header__search--active')) {
            pp.sitewide.closeSearchHeader();
        }
        $('body').toggleClass('layout-header__contact--active');

        if ($('body').hasClass('layout-header__contact--active')) {
            var focusElement = $(e.currentTarget.hash);

            focusElement.focus();
        }
    },
    toggleSearchHeader: function(e) {
        var activeClass = 'layout-header__search--active';
        e.preventDefault();
        $('body').toggleClass(activeClass);
        // If CONTACT is open, close it first
        if ($('body').hasClass('layout-header__contact--active')) {
            pp.sitewide.closeContactHeader();
        }
        if ($('body').hasClass(activeClass)) {
            $('.header-search__form input').focus();
        }
    },
    closeContactHeader: function(e) {
        if (e) {
            e.preventDefault();
        }
        $('body').removeClass('layout-header__contact--active');
    },
    closeSearchHeader: function(e) {
        if (e) {
            e.preventDefault();
        }
        $('body').removeClass('layout-header__search--active');
    },
    googleMaps: function() {

        function initialize() {
            // Map Queen Street
            var latLngQueenSt = new google.maps.LatLng(-37.813778, 144.960539);
            var mapOptionsQueenSt = {
                zoom: 15,
                scrollwheel: false,
                center: latLngQueenSt,
                draggable: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };


            if($('#map-queenst').length) {

                pp.sitewide.mapQueenSt = new google.maps.Map(document.getElementById('map-queenst'),mapOptionsQueenSt);

                var marker1 = new google.maps.Marker({
                    position: latLngQueenSt,
                    map: pp.sitewide.mapQueenSt,
                    icon: '/wp-content/themes/default/static/img/marker.png'
                });

            }

            if( document.getElementById('map-queenst-mobile') ) {
                // Map Queen streeet mobile
                var mapOptionsQueenStMobile = {
                    zoom: 15,
                    scrollwheel: false,
                    center: latLngQueenSt,
                    disableDefaultUI: true,
                    draggable: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                };

                pp.sitewide.mapQueenStMobile = new google.maps.Map(document.getElementById('map-queenst-mobile'), mapOptionsQueenStMobile);

                var marker2 = new google.maps.Marker({
                    position: latLngQueenSt,
                    map: pp.sitewide.mapQueenStMobile,
                    icon: '/wp-content/themes/default/static/img/marker.png'
                });
            }
            // Map Collin Street
            var latLngCollinsSt = new google.maps.LatLng(-37.813863, 144.970859);
            var mapOptionsCollinsSt = {
                zoom: 15,
                scrollwheel: false,
                center: latLngCollinsSt,
                draggable: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            if($('#map-collinsst').length) {

                pp.sitewide.mapCollinsSt = new google.maps.Map(document.getElementById('map-collinsst'), mapOptionsCollinsSt);

                var marker3 = new google.maps.Marker({
                    position: latLngCollinsSt,
                    map: pp.sitewide.mapCollinsSt,
                    icon: '/wp-content/themes/default/static/img/marker.png'
                });

            }

            // Map Collim Street Mobile
            var mapOptionsCollinsStMobile = {
                zoom: 15,
                scrollwheel: false,
                center: latLngCollinsSt,
                disableDefaultUI: true,
                draggable: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            if(document.getElementById('map-collinsst-mobile')){
                pp.sitewide.mapCollinsStMobile = new google.maps.Map(document.getElementById('map-collinsst-mobile'), mapOptionsCollinsStMobile);

                var marker4 = new google.maps.Marker({
                    position: latLngCollinsSt,
                    map: pp.sitewide.mapCollinsStMobile,
                    icon: '/wp-content/themes/default/static/img/marker.png'
                });
            }




            // Resize for clinic pages
            if($('.layout-map--zoomed').length && $('#map-collinsst').length) {
                pp.sitewide.mapCollinsSt.setZoom( 18 );
                pp.sitewide.mapCollinsSt.set('draggable', true);
            }
            if($('.layout-map--zoomed').length && $('#map-queenst').length) {
                pp.sitewide.mapQueenSt.setZoom( 18 );
                pp.sitewide.mapQueenSt.set('draggable', true);
            }



            // Resize events / Re center pins
            google.maps.event.addDomListener(window, "resize", function() {

                var centerQueenSt,
                    centerCollinsSt;

                // These maps only on some pages
                if ($('#map-collinsst').length && $('#map-queenst').length)  {

                    centerQueenSt = pp.sitewide.mapQueenSt.getCenter();
                    google.maps.event.trigger(pp.sitewide.mapQueenSt, "resize");
                    pp.sitewide.mapQueenSt.setCenter(centerQueenSt);

                    centerCollinsSt = pp.sitewide.mapCollinsSt.getCenter();
                    google.maps.event.trigger(pp.sitewide.mapCollinsSt, "resize");
                    pp.sitewide.mapCollinsSt.setCenter(centerCollinsSt);

                }

                if(pp.sitewide.mapQueenStMobile) {
                    centerQueenSt = pp.sitewide.mapQueenStMobile.getCenter();
                    google.maps.event.trigger(pp.sitewide.mapQueenStMobile, "resize");
                    pp.sitewide.mapQueenStMobile.setCenter(centerQueenSt);
                }

                if(pp.sitewide.mapCollinsStMobile) {
                    centerCollinsSt = pp.sitewide.mapCollinsStMobile.getCenter();
                    google.maps.event.trigger(pp.sitewide.mapCollinsStMobile, "resize");
                    pp.sitewide.mapCollinsStMobile.setCenter(centerCollinsSt);
                }


            });

            pp.sitewide.mapsLoaded = true;

        }

        function handleObserver(entries) {
            Array.from(entries).forEach(
                function(entry) {
                    if (!pp.sitewide.mapsLoaded && entry.isIntersecting) {
                        initialize();
                    }
                }
            );
        }

        var observer = new IntersectionObserver(handleObserver,  {
            rootMargin: '0px 0px 500px'
        });

        var maps = document.querySelectorAll('.map, .layout-map__map, .clinic-location__map');

        maps.forEach(
            function (el) {
                observer.observe(el);
            }
        );
    },
    images: function() {
        // Polyfill for object fit images in IE
        if (!Modernizr.objectfit) {
            objectFitImages();
        }
        // Lazyload images
        new LazyLoad();
    },
    setCards: function() {
        var $cardContainer = $('[data-js-min-height]');

        $cardContainer.each(function() {
            // Get cards
            var $cards = $(this).find('.card');
            var minHeight = 0;

            // Get maximum height of cards
            $cards.each(function() {
                if ($(this).outerHeight() > minHeight) {
                    minHeight = $(this).outerHeight();
                }
            });

            $cards.each(function() {
                $(this)[0].style.minHeight = minHeight + 'px';
            });
        });
    },
    externalLinks: function() {
        var $links = $('a[target="_blank"]');

        $links.each(function() {
            // Check if ref attribute exists, if no, add 'noopener' attribute for security reasons
            if (!this.rel) {
                this.rel = 'noopener';
            }
        });
    }
};

pp.helpers = function() {
    $('.js-scrollto').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate( { scrollTop: $(target).offset().top }, 400 );
    });
};

pp.forceLoad = function (element) {
    element.setAttribute('src', element.getAttribute('data-src'));
    element.classList.add('loaded');
};

pp.dropdown = function(){
    $("ul.dropdown li").each(function(){
        var $t = $(this);
        var $d = $t.find('.dropdown__content');
        $d.hide();
        $t.find('.dropdown__title').click(function(e){
            e.preventDefault();
            e.stopPropagation();
            $d.slideToggle('fast');
            $t.toggleClass('showing');
            $(this).attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true';
            });
            $t.find('.dropdown__title').each(function() {
                $(this).attr('aria-selected', 'false');
            });
            $(this).attr('aria-selected', 'true');

        });

    });
};

pp.stickySidebar = function(){
    // This must only execute after images have loaded
    $(window).bind("load", function() {
        if (Modernizr.mq('(min-width: 720px)')) {

            var $sticky = $('.sticky');

            if (!$sticky.length) {
                return;
            }

            // Top of page
            var stickyTop = $sticky.offset().top;
            var parentwidth = $(".sticky-parent").width();

            //Bottom of page
            var paddingBottom = 84;
            var paddingTop = 22;
            var stickyHeight = $(".sticky").height();
            var footerTop = $(".layout-footer").offset().top - paddingBottom;

            // If related articles module, change footerTop
            if ($('.related-articles').length) {
                footerTop = $('.related-articles').offset().top - paddingBottom;
            }

            $(window).scroll(function(e) {

                var windowTop = window.scrollY;

                // if the top of the sidebar touches the top of the window, make if fixed
                if (windowTop >= stickyTop - paddingTop)
                    $('.sticky').addClass('fixed').width(parentwidth);
                else
                    $('.sticky').removeClass('fixed');

                // if the bottom of the sidebar touches the top of the footer, make it move up
                if (windowTop + stickyHeight > footerTop)
                    $('.sticky').css({top: (windowTop + stickyHeight - footerTop) * -1});
                else
                    $('.sticky').css({top: 0});
            });

        }
    });
};

pp.fancyboxIdle = function(){
    jQuery.extend(jQuery.fancybox.defaults, {
        idleTime: false
    });
};

pp.fancyboxPricing = function(){
    jQuery("a#pricing-table-link").fancybox();
};

/*
 * Contact Form 7 tracking
 * https://contactform7.com/2017/06/07/on-sent-ok-is-deprecated/
 */
pp.formTracking = function(){
    document.addEventListener('wpcf7mailsent', function(event) {
        // Track contact form submissions
        dataLayer.push({'event': 'contactFormSubmitted'});

    }, false);
};

/*
 * Global button-click tracking (GTM dataLayer) — agreed with SEO 2026-08-27.
 * Any <a> that is visually a button — the theme's .button / .button-* classes,
 * or the next-available card's Book button (.apb-na-card__btn) — pushes:
 *   event: 'button_clicked'
 *   button_module:     the module the button belongs to — its data-tracking
 *                      value when set (curated per-module in the templates),
 *                      else the first class of the closest <section>, <footer>
 *                      or <header>, else ''.
 *   service_available: next-available card button only — the availability time
 *                      shown on the card (e.g. "today 2:30pm"); '' when still
 *                      loading, when nothing is bookable, or for other buttons.
 * String values are lowercased, matching the booking form's dataLayer policy
 * (see plugins/pracsuite-booking/docs/ANALYTICS-EVENTS.md). Links only — real
 * <button> elements (form submits, UI controls) are deliberately excluded.
 * Capture phase so intermediate handlers that call stopPropagation() (dropdowns,
 * fancybox, etc.) can't hide button clicks from us; this also means the event
 * measures clicks, not completed navigations. Best-effort: the whole handler is
 * wrapped so analytics can never break the page.
 */
pp.buttonTracking = function(){
    document.addEventListener('click', function(event) {
        try {
            var link = event.target instanceof Element ? event.target.closest('a') : null;
            if (!link) { return; }

            var isNaCardBtn = link.classList.contains('apb-na-card__btn');
            var isButton = isNaCardBtn;
            if (!isButton) {
                for (var i = 0; i < link.classList.length; i++) {
                    var cls = link.classList[i];
                    if (cls === 'button' || cls.indexOf('button-') === 0) { isButton = true; break; }
                }
            }
            if (!isButton) { return; }

            var buttonModule = link.getAttribute('data-tracking') || '';
            if (!buttonModule) {
                var section = link.closest('section, footer, header');
                if (section && section.classList.length) { buttonModule = section.classList[0]; }
            }

            var available = '';
            if (isNaCardBtn) {
                var card = link.closest('.apb-na-card');
                // Prefer the bare band from data-band (set by next-available.ts) so the
                // GA value stays stable ("this afternoon") even though the visible card
                // now shows a full phrase ("Available this afternoon") and a transient
                // "Checking availability…" state. Fall back to the visible value text.
                var dataBand = card ? card.getAttribute('data-band') : '';
                if (dataBand) {
                    available = dataBand.replace(/\s+/g, ' ').trim();
                } else {
                    var value = card ? card.querySelector('.apb-na-card__value') : null;
                    available = value ? value.textContent.replace(/\s+/g, ' ').trim() : '';
                }
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'button_clicked',
                button_module: buttonModule.toLowerCase(),
                service_available: available.toLowerCase()
            });
        } catch (e) {
            /* analytics is best-effort — never break the page */
        }
    }, true);
};


pp.marketingBanner = {
    initialised: false,
    localStorageKey: 'close-global-banner',
    isExpanded: false,
    isDismissed: false,
    el: document.querySelector('#global-banner'),
    init: function () {
        this.isDismissed = localStorage.getItem(this.localStorageKey);
        if (!this.el) {
            return;
        }

        if (!this.isDismissed) {
            this.eventListener();
            this.show();
        }

        this.initialised = true;
    },
    show: function () {
        this.el.setAttribute('aria-expanded', true);
        this.el.setAttribute('aria-hidden', false);
        this.el.inert = false;
        this.el.removeAttribute('tabIndex');

        // Animate in
        this.el.classList.add('is-open');

        // Set keyboard focus
        this.el.focus();
    },
    close: function () {
        this.el.setAttribute('aria-expanded', false);
        this.el.setAttribute('aria-hidden', true);
        this.el.inert = true;
        this.el.tabIndex = -1;

        // Animate out
        this.el.classList.remove('is-open');

        localStorage.setItem(this.localStorageKey, 'true');
    },
    eventListener: function () {
        var close = this.el.querySelector('#global-banner-close');

        // Need to bind this close

        if (close) {
            close.addEventListener('click', this.close.bind(this));
        }
    }
};

// Place any site scripts to be run here
// --------------------------------------------------
(function() {
    $(document).ready(function(){
        $(document).foundation();
        pp.sitewide.init();
        pp.home.init();
        pp.contact.init();
        pp.post.init();
        pp.nav.init();
        pp.helpers();
        pp.dropdown();
        pp.stickySidebar();
        pp.fancyboxIdle();
        pp.fancyboxPricing();
        pp.formTracking();
        pp.buttonTracking();
        pp.iframe.init();
        pp.people.init();
        pp.socialFeed.init();
        pp.marketingBanner.init();
        pp.service.init();
    });
}());
